export function openSigninModal(event: Event) {
  // Show mobile modal
  if ((window as any).showSigninModal) {
    (window as any).showSigninModal(event);
    return;
  }

  // Show desktop modal
  (window as any).WantedlyApp.Views.Popup.Signin.openDialog(event, {
    modalExperimentEnabled: document.body.classList.contains("modal-experiment-enabled"),
  });
}



// WEBPACK FOOTER //
// ./frontend/src/lib/auth.ts